import { Terminal } from "lucide-react";
import { useLang } from "@/lib/i18n";

const HERO_BG_STYLE = {
  backgroundImage:
    "url(/images/hero-bg.jpg)",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

export default function HeroSection() {
  const { t } = useLang();
  return (
    <section
      className="relative border-b border-black/10 dark:border-white/10 overflow-hidden"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={HERO_BG_STYLE}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-8 md:py-10">
        <div className="flex items-center gap-2 text-[10px] md:text-xs font-mono uppercase tracking-widest text-[#00ff66] mb-2">
          <Terminal className="w-3 h-3 md:w-3.5 md:h-3.5" />
          <span>zero-knowledge // aes-256-gcm</span>
        </div>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter text-neutral-900 dark:text-white leading-[0.95] max-w-3xl">
          {t("heroTitle")}
        </h1>
        <p className="mt-2 text-sm md:text-base text-neutral-600 dark:text-neutral-400 max-w-2xl leading-snug">
          {t("heroSub")}
        </p>
      </div>
    </section>
  );
}
